/** The query param that carries where to go after logging in (set by the auth guards). */
export const RETURN_URL_QUERY_PARAM = 'returnUrl'

/** Pages it makes no sense to come back to after logging in. */
const AUTH_PAGES = ['/login', '/signup', '/forgot-password', '/reset-password', '/verify-email']

/**
 * `url` if it's a page in this app worth returning to after login, else null. Only same-origin paths:
 * `returnUrl` comes from the address bar, so anything else ("//evil.com", "https://...",
 * "/\evil.com", "javascript:") could send someone off-site after they type their password.
 */
export function safeReturnUrl(url: string | null | undefined): string | null {
  if (!url || !url.startsWith('/') || url.startsWith('//') || url.startsWith('/\\')) {
    return null
  }
  let parsed: URL
  try {
    parsed = new URL(url, 'https://corpers.invalid')
  } catch {
    return null
  }
  if (parsed.origin !== 'https://corpers.invalid' || parsed.pathname === '/') {
    return null
  }
  if (AUTH_PAGES.some((page) => parsed.pathname === page || parsed.pathname.startsWith(page + '/'))) {
    return null
  }
  return parsed.pathname + parsed.search + parsed.hash
}
